import '../../monitoring/filters/text_filter_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.TextFilterView extends Monitoring.Views.SocialContents.Filters.TextFilterView
  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
